import store from "../store/store";
import { api } from "./api";
import { endpoints } from "./endpoints";
import {
  Login,
  LinkTicketmasterAccount,
  GetUserVendorMappingPayload,
  RefreshTokenResponse,
  RegisterLocal,
} from "@/types";

export const LoginApi = () => async (payload: Login) => {
  return await api.post(endpoints.login, payload);
};

export const RegisterApi = () => async (payload: RegisterLocal) => {
  return await api.post(endpoints.register, payload);
};

export const getAuthURLApi = async (teamSchema: string) =>
  await api.post(endpoints.getAuthURL, { teamSchema });

export const linkTicketmasterAccountApi =
  () => async (payload: LinkTicketmasterAccount) =>
    await api.post(endpoints.linkTicketmasterAccount, payload);

export const getUserVendorMappingApi =
  () =>
  async ({ schema }: GetUserVendorMappingPayload) =>
    await api.post(endpoints.getUserVendorMapping, { schema });

export const refreshToken = async (
  error: Error
): Promise<RefreshTokenResponse> => {
  return new Promise((resolve, reject) => {
    try {
      const user = store.getState()?.user;
      const { token } = user;

      api
        .post(endpoints.refreshToken, { token })
        .then((res) => resolve(res))
        .catch(() => reject(error));
    } catch (err) {
      return reject(err);
    }
  });
};

export const userPingApi = () => {
  return api.post(endpoints.userPing);
};

export const forgotPasswordApi = async (payload: {
  email: string;
  teamSchema: string;
  callback?: string;
}) => await api.post(endpoints.forgotPassword, payload);

export const resetPasswordApi = async (payload: {
  teamSchema: string;
  email: string;
  password: string;
  resetToken: string;
}) => await api.post(endpoints.resetPassword, payload);

export const getCustomerAccountApi = async (payload: {
  teamSchema: string;
  accountId: number;
}) => await api.post(endpoints.getCustomerAccount, payload);
